<template>
  <div class="footer-wrapper">
    <div class="footer-main">
      <!-- Link Columns -->
      <div
        class="footer-col"
        v-for="(linkGroup, index) in linkGroups"
        :key="linkGroup.heading"
        @click="toggle(index)"
      >
        <h3 :class="{ 'header-closed': !linkGroup.isOpen }">
          {{ linkGroup.heading }}
          <span class="toggle-icon">{{ linkGroup.isOpen ? "-" : "+" }}</span>
        </h3>
        <ul
          :class="{ 'is-open': linkGroup.isOpen }"
          @transitionend="handleTransitionEnd"
        >
          <li v-for="{ name, url } in linkGroup.links" :key="name">
            <a @click="invsyLink(url)">{{ name }}</a>
          </li>
        </ul>
      </div>
      <div class="footer-col">
        <!-- Social icons -->
        <div class="social-links-wrapper">
          <a
            v-for="{ name, url, svgName } in socialLinks"
            :key="name"
            @click="invsyLink(url)"
            :aria-label="name"
            target="_blank"
            role="link"
            rel="noopener noreferrer"
            class="social-link"
          >
            <img :src="getIcon(svgName)" :alt="name" class="social-icon" />
          </a>
        </div>
      </div>
    </div>
    <!-- Bottom bar -->
    <div class="footer-bottom">
      <div class="footer-bottom-inner">
        &copy; {{ companyName }} {{ new Date().getFullYear() }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      companyName: "Investec",
      linkGroups: [
        // Legal information
        {
          heading: "Legal information",
          links: [
            {
              name: "Accessibility",
              url: "https://www.investec.com/en_za/accessibility.html",
            },
            {
              name: "Legal",
              url: "https://www.investec.com/en_za/legal/SA.html",
            },
            {
              name: "Fraud",
              url: "https://www.investec.com/en_za/legal/know-fraud.html",
            },
            {
              name: "Privacy policy",
              url: "https://www.investec.com/en_za/legal/privacy-policy.html",
            },
            {
              name: "Terms and conditions",
              url: "https://www.investectravel.com/terms-and-conditions/",
            },
          ],
          isOpen: false,
        },
        // Get in touch
        {
          heading: "Get in touch",
          links: [
            {
              name: "Contact us",
              url: "https://www.investectravel.com/contact-us/",
            },
            {
              name: "Careers",
              url:
                "https://www.investec.com/en_za/welcome-to-investec/Careers.html",
            },
          ],
          isOpen: false,
        },
        // Other information
        {
          heading: "Other information",
          links: [
            {
              name: "Investec Property",
              url: "https://www.investecproperty.com/en_za.html",
            },
            {
              name: "Developer",
              url: "https://developer.investec.com/za/home",
            },
            {
              name: "Clarity by Investec",
              url:
                "https://nowclarity.com/?medium=referral&source=website-investec.com&campaign=sa-cly-investec-dot-com-referrals&content=from-footer&up_id=390126a",
            },
          ],
          isOpen: false,
        },
      ],
      socialLinks: [
        {
          name: "facebook",
          svgName: "facebook-icon",
          url: "https://www.facebook.com/InvestecBank/",
        },
        {
          name: "twitter",
          svgName: "twitter-icon",
          url: "https://twitter.com/Investec",
        },
        {
          name: "linkedin",
          svgName: "linkedin-icon",
          url: "https://www.linkedin.com/company/investec",
        },
        {
          name: "instagram",
          svgName: "instagram-icon",
          url: "https://www.instagram.com/investec/",
        },
        {
          name: "youtube",
          svgName: "youtube-icon",
          url: "https://www.youtube.com/user/investec",
        },
      ],
    };
  },
  methods: {
    invsyLink(url) {
      this.$store.dispatch("invsyLink", url);
    },
    getIcon(path) {
      return require(`@/assets/images/icons/${path}.svg`);
    },
    toggle(index) {
      this.linkGroups[index].isOpen = !this.linkGroups[index].isOpen;
    },
    handleTransitionEnd(event) {
      if (event.propertyName === "max-height") {
        this.$emit("after-toggle");
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/variables.scss";

$footer-padding: 16px;
$footer-margin: 32px;

.footer-wrapper {
  margin-top: $footer-margin;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
}

.footer-main {
  display: flex;
  justify-content: space-between;
  width: 100%;
  background-color: #303849;
  color: #fff;
  padding: 4 * $footer-padding;
  padding-top: 6 * $footer-padding;
  font-family: "Inter", sans-serif;
  font-style: normal;
  font-weight: normal;

  @media (max-width: 768px) {
    flex-direction: column;
  }
}

.footer-col {
  flex: 1;
  font-size: 16px;
  line-height: 24px;
  padding-left: $footer-padding;
  padding-right: $footer-padding;
  position: relative;

  &::after {
    content: "";
    position: absolute;
    left: $footer-padding;
    right: $footer-padding;
    height: 2px;
    background-color: #eaebec;
    top: 76px;
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }

  &:has(h3.header-closed)::after {
    opacity: 1;
  }

  h3 {
    font-family: "Inter", sans-serif;
    font-weight: 500;
    line-height: 28px;
    font-size: 20px;
    cursor: pointer;
    margin-bottom: 16px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding-bottom: 24px;
    transition: margin-bottom 0.3s ease-in-out;
    color: #cd934d;

    &.header-closed {
      color: #eaebec;
      margin-bottom: 64px;
    }

    .toggle-icon {
      border: 2px solid #eaebec;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      color: #eaebec;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 20px;
      line-height: 24px;
      padding-bottom: 4px;
      flex-shrink: 0;
      margin-left: 12px;
      margin-top: 2px;
    }
  }

  ul {
    list-style: none;
    padding: 0;
    border-left: 1.5px solid rgba(255, 255, 255, 0.25);
    padding-left: 16px;
    max-height: 0;
    opacity: 0;
    overflow: hidden;
    transition: max-height 0.5s ease-in-out, opacity 0.3s ease-in-out;
    margin-bottom: 32px;

    li {
      margin-bottom: 32px;

      a {
        text-decoration: underline;
        color: #fff;
        font-weight: 600;

        &:hover {
          text-decoration: underline;
        }
      }

      a:hover {
        padding-left: 1rem;
        // smooth transition for hover effect back and forward
        transition: all 0.1s ease-in-out;
      }
    }
  }
  ul.is-open {
    max-height: 500px;
    opacity: 1;
  }

  .social-links-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;

    .social-link {
      display: flex;
      justify-content: center;
      align-items: center;

      .social-icon {
        width: 24px;
        height: 24px;
      }
    }
  }
}

.footer-bottom {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: left;
  padding: 0 4 * $footer-padding $footer-margin;
  background-color: #303849;

  .footer-bottom-inner {
    width: 100%;
    padding: 16px 0;
    border-top: 1.5px solid rgba(255, 255, 255, 0.25);
    color: rgba(255, 255, 255, 0.8);
    font-size: 14px;
    line-height: 20px;
    font-weight: 500;
  }
}

@media (max-width: 480px) {
  .footer-main {
    padding: 2 * $footer-padding;
  }
}
</style>
